export default __webpack_public_path__ + "static/media/AlertCheck.3eff50af.svg";